import { _ as _extends } from './_rollupPluginBabelHelpers-e8fb2e5c.js';
import React__default, { forwardRef, useContext, useRef, useState, useMemo, useEffect, useCallback } from 'react';
import { c as commonjsGlobal } from './_commonjsHelpers-24198af3.js';
import ReactDOM__default from 'react-dom';
import { u as useSwipeable } from './index-122432cd.js';
import { c as classnames } from './index-031ff73c.js';
import PropTypes from 'prop-types';
import { n as noop, s as stopEvent } from './index-a0e4e333.js';
import useDeviceType from './hooks/useDeviceType.js';
import useClickOutside from './hooks/useClickOutside.js';
import { f as popoverV2Config, s as screenTypes } from './configs-1fb8eed2.js';
import CustomScrollbar from './Scrollbar/index.js';
import { GeneUIDesignSystemContext } from './GeneUIProvider/index.js';
import { s as styleInject } from './style-inject.es-746bb8ed.js';
import { d as debounce } from './debounce-4419bc2f.js';

var Popover = {};

var jsxRuntimeExports = {};
var jsxRuntime = {
  get exports(){ return jsxRuntimeExports; },
  set exports(v){ jsxRuntimeExports = v; },
};

var reactJsxRuntime_production_min = {};

/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min () {
	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
	hasRequiredReactJsxRuntime_production_min = 1;
var f=React__default,g=60103;reactJsxRuntime_production_min.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");reactJsxRuntime_production_min.Fragment=h("react.fragment");}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
	function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;
	return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

/** @license React v16.14.0
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;
	(function (exports) {

		if (process.env.NODE_ENV !== "production") {
		  (function() {

		var React = React__default;

		// ATTENTION
		// When adding new symbols to this file,
		// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
		// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
		// nor polyfill, then a plain number is used for performance.
		var REACT_ELEMENT_TYPE = 0xeac7;
		var REACT_PORTAL_TYPE = 0xeaca;
		exports.Fragment = 0xeacb;
		var REACT_STRICT_MODE_TYPE = 0xeacc;
		var REACT_PROFILER_TYPE = 0xead2;
		var REACT_PROVIDER_TYPE = 0xeacd;
		var REACT_CONTEXT_TYPE = 0xeace;
		var REACT_FORWARD_REF_TYPE = 0xead0;
		var REACT_SUSPENSE_TYPE = 0xead1;
		var REACT_SUSPENSE_LIST_TYPE = 0xead8;
		var REACT_MEMO_TYPE = 0xead3;
		var REACT_LAZY_TYPE = 0xead4;
		var REACT_BLOCK_TYPE = 0xead9;
		var REACT_SERVER_BLOCK_TYPE = 0xeada;
		var REACT_FUNDAMENTAL_TYPE = 0xead5;
		var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
		var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

		if (typeof Symbol === 'function' && Symbol.for) {
		  var symbolFor = Symbol.for;
		  REACT_ELEMENT_TYPE = symbolFor('react.element');
		  REACT_PORTAL_TYPE = symbolFor('react.portal');
		  exports.Fragment = symbolFor('react.fragment');
		  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
		  REACT_PROFILER_TYPE = symbolFor('react.profiler');
		  REACT_PROVIDER_TYPE = symbolFor('react.provider');
		  REACT_CONTEXT_TYPE = symbolFor('react.context');
		  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
		  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
		  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
		  REACT_MEMO_TYPE = symbolFor('react.memo');
		  REACT_LAZY_TYPE = symbolFor('react.lazy');
		  REACT_BLOCK_TYPE = symbolFor('react.block');
		  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
		  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
		  symbolFor('react.scope');
		  symbolFor('react.opaque.id');
		  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
		  symbolFor('react.offscreen');
		  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
		}

		var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		var FAUX_ITERATOR_SYMBOL = '@@iterator';
		function getIteratorFn(maybeIterable) {
		  if (maybeIterable === null || typeof maybeIterable !== 'object') {
		    return null;
		  }

		  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

		  if (typeof maybeIterator === 'function') {
		    return maybeIterator;
		  }

		  return null;
		}

		var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

		function error(format) {
		  {
		    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
		      args[_key2 - 1] = arguments[_key2];
		    }

		    printWarning('error', format, args);
		  }
		}

		function printWarning(level, format, args) {
		  // When changing this logic, you might want to also
		  // update consoleWithStackDev.www.js as well.
		  {
		    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
		    var stack = '';

		    if (currentlyValidatingElement) {
		      var name = getComponentName(currentlyValidatingElement.type);
		      var owner = currentlyValidatingElement._owner;
		      stack += describeComponentFrame(name, currentlyValidatingElement._source, owner && getComponentName(owner.type));
		    }

		    stack += ReactDebugCurrentFrame.getStackAddendum();

		    if (stack !== '') {
		      format += '%s';
		      args = args.concat([stack]);
		    }

		    var argsWithFormat = args.map(function (item) {
		      return '' + item;
		    }); // Careful: RN currently depends on this prefix

		    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
		    // breaks IE9: https://github.com/facebook/react/issues/13610
		    // eslint-disable-next-line react-internal/no-production-logging

		    Function.prototype.apply.call(console[level], console, argsWithFormat);
		  }
		}

		// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

		var enableScopeAPI = false; // Experimental Create Event Handle API.

		function isValidElementType(type) {
		  if (typeof type === 'string' || typeof type === 'function') {
		    return true;
		  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


		  if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
		    return true;
		  }

		  if (typeof type === 'object' && type !== null) {
		    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
		      return true;
		    }
		  }

		  return false;
		}


		var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
		function describeComponentFrame (name, source, ownerName) {
		  var sourceInfo = '';

		  if (source) {
		    var path = source.fileName;
		    var fileName = path.replace(BEFORE_SLASH_RE, '');

		    {
		      // In DEV, include code for a common special case:
		      // prefer "folder/index.js" instead of just "index.js".
		      if (/^index\./.test(fileName)) {
		        var match = path.match(BEFORE_SLASH_RE);

		        if (match) {
		          var pathBeforeSlash = match[1];

		          if (pathBeforeSlash) {
		            var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, '');
		            fileName = folderName + '/' + fileName;
		          }
		        }
		      }
		    }

		    sourceInfo = ' (at ' + fileName + ':' + source.lineNumber + ')';
		  } else if (ownerName) {
		    sourceInfo = ' (created by ' + ownerName + ')';
		  }

		  return '\n    in ' + (name || 'Unknown') + sourceInfo;
		}

		var Resolved = 1;
		function refineResolvedLazyComponent(lazyComponent) {
		  return lazyComponent._status === Resolved ? lazyComponent._result : null;
		}

		function getWrappedName(outerType, innerType, wrapperName) {
		  var functionName = innerType.displayName || innerType.name || '';
		  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
		}

		function getComponentName(type) {
		  if (type == null) {
		    // Host root, text node or just invalid type.
		    return null;
		  }

		  {
		    if (typeof type.tag === 'number') {
		      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
		    }
		  }

		  if (typeof type === 'function') {
		    return type.displayName || type.name || null;
		  }

		  if (typeof type === 'string') {
		    return type;
		  }

		  switch (type) {
		    case exports.Fragment:
		      return 'Fragment';

		    case REACT_PORTAL_TYPE:
		      return 'Portal';

		    case REACT_PROFILER_TYPE:
		      return "Profiler";

		    case REACT_STRICT_MODE_TYPE:
		      return 'StrictMode';

		    case REACT_SUSPENSE_TYPE:
		      return 'Suspense';

		    case REACT_SUSPENSE_LIST_TYPE:
		      return 'SuspenseList';
		  }

		  if (typeof type === 'object') {
		    switch (type.$$typeof) {
		      case REACT_CONTEXT_TYPE:
		        return 'Context.Consumer';

		      case REACT_PROVIDER_TYPE:
		        return 'Context.Provider';

		      case REACT_FORWARD_REF_TYPE:
		        return getWrappedName(type, type.render, 'ForwardRef');

		      case REACT_MEMO_TYPE:
		        return getComponentName(type.type);

		      case REACT_BLOCK_TYPE:
		        return getComponentName(type.render);

		      case REACT_LAZY_TYPE:
		        {
		          var thenable = type;
		          var resolvedThenable = refineResolvedLazyComponent(thenable);

		          if (resolvedThenable) {
		            return getComponentName(resolvedThenable);
		          }

		          break;
		        }
		    }
		  }

		  return null;
		}

		var loggedTypeFailures = {};
		ReactSharedInternals.ReactDebugCurrentFrame;
		var currentlyValidatingElement = null;

		function setCurrentlyValidatingElement(element) {
		  {
		    currentlyValidatingElement = element;
		  }
		}

		function checkPropTypes(typeSpecs, values, location, componentName, element) {
		  {
		    // $FlowFixMe This is okay but Flow doesn't know it.
		    var has = Function.call.bind(Object.prototype.hasOwnProperty);

		    for (var typeSpecName in typeSpecs) {
		      if (has(typeSpecs, typeSpecName)) {
		        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.

		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          if (typeof typeSpecs[typeSpecName] !== 'function') {
		            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
		            err.name = 'Invariant Violation';
		            throw err;
		          }

		          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
		        } catch (ex) {
		          error$1 = ex;
		        }

		        if (error$1 && !(error$1 instanceof Error)) {
		          setCurrentlyValidatingElement(element);

		          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

		          setCurrentlyValidatingElement(null);
		        }

		        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error$1.message] = true;
		          setCurrentlyValidatingElement(element);

		          error('Failed %s type: %s', location, error$1.message);

		          setCurrentlyValidatingElement(null);
		        }
		      }
		    }
		  }
		}

		var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var RESERVED_PROPS = {
		  key: true,
		  ref: true,
		  __self: true,
		  __source: true
		};
		var specialPropKeyWarningShown;
		var specialPropRefWarningShown;
		var didWarnAboutStringRefs;

		{
		  didWarnAboutStringRefs = {};
		}

		function hasValidRef(config) {
		  {
		    if (hasOwnProperty.call(config, 'ref')) {
		      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

		      if (getter && getter.isReactWarning) {
		        return false;
		      }
		    }
		  }

		  return config.ref !== undefined;
		}

		function hasValidKey(config) {
		  {
		    if (hasOwnProperty.call(config, 'key')) {
		      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

		      if (getter && getter.isReactWarning) {
		        return false;
		      }
		    }
		  }

		  return config.key !== undefined;
		}

		function warnIfStringRefCannotBeAutoConverted(config, self) {
		  {
		    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
		      var componentName = getComponentName(ReactCurrentOwner.current.type);

		      if (!didWarnAboutStringRefs[componentName]) {
		        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);

		        didWarnAboutStringRefs[componentName] = true;
		      }
		    }
		  }
		}

		function defineKeyPropWarningGetter(props, displayName) {
		  {
		    var warnAboutAccessingKey = function () {
		      if (!specialPropKeyWarningShown) {
		        specialPropKeyWarningShown = true;

		        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
		      }
		    };

		    warnAboutAccessingKey.isReactWarning = true;
		    Object.defineProperty(props, 'key', {
		      get: warnAboutAccessingKey,
		      configurable: true
		    });
		  }
		}

		function defineRefPropWarningGetter(props, displayName) {
		  {
		    var warnAboutAccessingRef = function () {
		      if (!specialPropRefWarningShown) {
		        specialPropRefWarningShown = true;

		        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
		      }
		    };

		    warnAboutAccessingRef.isReactWarning = true;
		    Object.defineProperty(props, 'ref', {
		      get: warnAboutAccessingRef,
		      configurable: true
		    });
		  }
		}
		/**
		 * Factory method to create a new React element. This no longer adheres to
		 * the class pattern, so do not use new to call it. Also, instanceof check
		 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
		 * if something is a React Element.
		 *
		 * @param {*} type
		 * @param {*} props
		 * @param {*} key
		 * @param {string|object} ref
		 * @param {*} owner
		 * @param {*} self A *temporary* helper to detect places where `this` is
		 * different from the `owner` when React.createElement is called, so that we
		 * can warn. We want to get rid of owner and replace string `ref`s with arrow
		 * functions, and as long as `this` and owner are the same, there will be no
		 * change in behavior.
		 * @param {*} source An annotation object (added by a transpiler or otherwise)
		 * indicating filename, line number, and/or other information.
		 * @internal
		 */


		var ReactElement = function (type, key, ref, self, source, owner, props) {
		  var element = {
		    // This tag allows us to uniquely identify this as a React Element
		    $$typeof: REACT_ELEMENT_TYPE,
		    // Built-in properties that belong on the element
		    type: type,
		    key: key,
		    ref: ref,
		    props: props,
		    // Record the component responsible for creating this element.
		    _owner: owner
		  };

		  {
		    // The validation flag is currently mutative. We put it on
		    // an external backing store so that we can freeze the whole object.
		    // This can be replaced with a WeakMap once they are implemented in
		    // commonly used development environments.
		    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
		    // the validation flag non-enumerable (where possible, which should
		    // include every environment we run tests in), so the test framework
		    // ignores it.

		    Object.defineProperty(element._store, 'validated', {
		      configurable: false,
		      enumerable: false,
		      writable: true,
		      value: false
		    }); // self and source are DEV only properties.

		    Object.defineProperty(element, '_self', {
		      configurable: false,
		      enumerable: false,
		      writable: false,
		      value: self
		    }); // Two elements created in two different places should be considered
		    // equal for testing purposes and therefore we hide it from enumeration.

		    Object.defineProperty(element, '_source', {
		      configurable: false,
		      enumerable: false,
		      writable: false,
		      value: source
		    });

		    if (Object.freeze) {
		      Object.freeze(element.props);
		      Object.freeze(element);
		    }
		  }

		  return element;
		};
		/**
		 * https://github.com/reactjs/rfcs/pull/107
		 * @param {*} type
		 * @param {object} props
		 * @param {string} key
		 */

		function jsxDEV(type, config, maybeKey, source, self) {
		  {
		    var propName; // Reserved names are extracted

		    var props = {};
		    var key = null;
		    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
		    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
		    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
		    // but as an intermediary step, we will use jsxDEV for everything except
		    // <div {...props} key="Hi" />, because we aren't currently able to tell if
		    // key is explicitly declared to be undefined or not.

		    if (maybeKey !== undefined) {
		      key = '' + maybeKey;
		    }

		    if (hasValidKey(config)) {
		      key = '' + config.key;
		    }

		    if (hasValidRef(config)) {
		      ref = config.ref;
		      warnIfStringRefCannotBeAutoConverted(config, self);
		    } // Remaining properties are added to a new props object


		    for (propName in config) {
		      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
		        props[propName] = config[propName];
		      }
		    } // Resolve default props


		    if (type && type.defaultProps) {
		      var defaultProps = type.defaultProps;

		      for (propName in defaultProps) {
		        if (props[propName] === undefined) {
		          props[propName] = defaultProps[propName];
		        }
		      }
		    }

		    if (key || ref) {
		      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

		      if (key) {
		        defineKeyPropWarningGetter(props, displayName);
		      }

		      if (ref) {
		        defineRefPropWarningGetter(props, displayName);
		      }
		    }

		    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
		  }
		}

		var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
		ReactSharedInternals.ReactDebugCurrentFrame;

		function setCurrentlyValidatingElement$1(element) {
		  currentlyValidatingElement = element;
		}

		var propTypesMisspellWarningShown;

		{
		  propTypesMisspellWarningShown = false;
		}
		/**
		 * Verifies the object is a ReactElement.
		 * See https://reactjs.org/docs/react-api.html#isvalidelement
		 * @param {?object} object
		 * @return {boolean} True if `object` is a ReactElement.
		 * @final
		 */

		function isValidElement(object) {
		  {
		    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
		  }
		}

		function getDeclarationErrorAddendum() {
		  {
		    if (ReactCurrentOwner$1.current) {
		      var name = getComponentName(ReactCurrentOwner$1.current.type);

		      if (name) {
		        return '\n\nCheck the render method of `' + name + '`.';
		      }
		    }

		    return '';
		  }
		}

		function getSourceInfoErrorAddendum(source) {
		  {
		    if (source !== undefined) {
		      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
		      var lineNumber = source.lineNumber;
		      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
		    }

		    return '';
		  }
		}
		/**
		 * Warn if there's no key explicitly set on dynamic arrays of children or
		 * object keys are not valid. This allows us to keep track of children between
		 * updates.
		 */


		var ownerHasKeyUseWarning = {};

		function getCurrentComponentErrorInfo(parentType) {
		  {
		    var info = getDeclarationErrorAddendum();

		    if (!info) {
		      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

		      if (parentName) {
		        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
		      }
		    }

		    return info;
		  }
		}
		/**
		 * Warn if the element doesn't have an explicit key assigned to it.
		 * This element is in an array. The array could grow and shrink or be
		 * reordered. All children that haven't already been validated are required to
		 * have a "key" property assigned to it. Error statuses are cached so a warning
		 * will only be shown once.
		 *
		 * @internal
		 * @param {ReactElement} element Element that requires a key.
		 * @param {*} parentType element's parent's type.
		 */


		function validateExplicitKey(element, parentType) {
		  {
		    if (!element._store || element._store.validated || element.key != null) {
		      return;
		    }

		    element._store.validated = true;
		    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

		    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
		      return;
		    }

		    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
		    // property, it may be the creator of the child that's responsible for
		    // assigning it a key.

		    var childOwner = '';

		    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
		      // Give the component that originally created this child.
		      childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
		    }

		    setCurrentlyValidatingElement$1(element);

		    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

		    setCurrentlyValidatingElement$1(null);
		  }
		}
		/**
		 * Ensure that every element either is passed in a static location, in an
		 * array with an explicit keys property defined, or in an object literal
		 * with valid key property.
		 *
		 * @internal
		 * @param {ReactNode} node Statically passed child of any type.
		 * @param {*} parentType node's parent's type.
		 */


		function validateChildKeys(node, parentType) {
		  {
		    if (typeof node !== 'object') {
		      return;
		    }

		    if (Array.isArray(node)) {
		      for (var i = 0; i < node.length; i++) {
		        var child = node[i];

		        if (isValidElement(child)) {
		          validateExplicitKey(child, parentType);
		        }
		      }
		    } else if (isValidElement(node)) {
		      // This element was passed in a valid location.
		      if (node._store) {
		        node._store.validated = true;
		      }
		    } else if (node) {
		      var iteratorFn = getIteratorFn(node);

		      if (typeof iteratorFn === 'function') {
		        // Entry iterators used to provide implicit keys,
		        // but now we print a separate warning for them later.
		        if (iteratorFn !== node.entries) {
		          var iterator = iteratorFn.call(node);
		          var step;

		          while (!(step = iterator.next()).done) {
		            if (isValidElement(step.value)) {
		              validateExplicitKey(step.value, parentType);
		            }
		          }
		        }
		      }
		    }
		  }
		}
		/**
		 * Given an element, validate that its props follow the propTypes definition,
		 * provided by the type.
		 *
		 * @param {ReactElement} element
		 */


		function validatePropTypes(element) {
		  {
		    var type = element.type;

		    if (type === null || type === undefined || typeof type === 'string') {
		      return;
		    }

		    var propTypes;

		    if (typeof type === 'function') {
		      propTypes = type.propTypes;
		    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
		    // Inner props are checked in the reconciler.
		    type.$$typeof === REACT_MEMO_TYPE)) {
		      propTypes = type.propTypes;
		    } else {
		      return;
		    }

		    if (propTypes) {
		      // Intentionally inside to avoid triggering lazy initializers:
		      var name = getComponentName(type);
		      checkPropTypes(propTypes, element.props, 'prop', name, element);
		    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
		      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

		      var _name = getComponentName(type);

		      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
		    }

		    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
		      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
		    }
		  }
		}
		/**
		 * Given a fragment, validate that it can only be provided with fragment props
		 * @param {ReactElement} fragment
		 */


		function validateFragmentProps(fragment) {
		  {
		    var keys = Object.keys(fragment.props);

		    for (var i = 0; i < keys.length; i++) {
		      var key = keys[i];

		      if (key !== 'children' && key !== 'key') {
		        setCurrentlyValidatingElement$1(fragment);

		        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

		        setCurrentlyValidatingElement$1(null);
		        break;
		      }
		    }

		    if (fragment.ref !== null) {
		      setCurrentlyValidatingElement$1(fragment);

		      error('Invalid attribute `ref` supplied to `React.Fragment`.');

		      setCurrentlyValidatingElement$1(null);
		    }
		  }
		}

		function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
		  {
		    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
		    // succeed and there will likely be errors in render.

		    if (!validType) {
		      var info = '';

		      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
		        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
		      }

		      var sourceInfo = getSourceInfoErrorAddendum(source);

		      if (sourceInfo) {
		        info += sourceInfo;
		      } else {
		        info += getDeclarationErrorAddendum();
		      }

		      var typeString;

		      if (type === null) {
		        typeString = 'null';
		      } else if (Array.isArray(type)) {
		        typeString = 'array';
		      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
		        typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
		        info = ' Did you accidentally export a JSX literal instead of a component?';
		      } else {
		        typeString = typeof type;
		      }

		      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
		    }

		    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
		    // TODO: Drop this when these are no longer allowed as the type argument.

		    if (element == null) {
		      return element;
		    } // Skip key warning if the type isn't valid since our key validation logic
		    // doesn't expect a non-string/function type and can throw confusing errors.
		    // We don't want exception behavior to differ between dev and prod.
		    // (Rendering will throw with a helpful message and as soon as the type is
		    // fixed, the key warnings will appear.)


		    if (validType) {
		      var children = props.children;

		      if (children !== undefined) {
		        if (isStaticChildren) {
		          if (Array.isArray(children)) {
		            for (var i = 0; i < children.length; i++) {
		              validateChildKeys(children[i], type);
		            }

		            if (Object.freeze) {
		              Object.freeze(children);
		            }
		          } else {
		            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
		          }
		        } else {
		          validateChildKeys(children, type);
		        }
		      }
		    }

		    if (type === exports.Fragment) {
		      validateFragmentProps(element);
		    } else {
		      validatePropTypes(element);
		    }

		    return element;
		  }
		} // These two functions exist to still get child warnings in dev
		// even with the prod transform. This means that jsxDEV is purely
		// opt-in behavior for better messages but that we won't stop
		// giving you warnings if you use production apis.

		function jsxWithValidationStatic(type, props, key) {
		  {
		    return jsxWithValidation(type, props, key, true);
		  }
		}
		function jsxWithValidationDynamic(type, props, key) {
		  {
		    return jsxWithValidation(type, props, key, false);
		  }
		}

		var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
		// for now we can ship identical prod functions

		var jsxs =  jsxWithValidationStatic ;

		exports.jsx = jsx;
		exports.jsxs = jsxs;
		  })();
		}
} (reactJsxRuntime_development));
	return reactJsxRuntime_development;
}

(function (module) {

	if (process.env.NODE_ENV === 'production') {
	  module.exports = requireReactJsxRuntime_production_min();
	} else {
	  module.exports = requireReactJsxRuntime_development();
	}
} (jsxRuntime));

var PopoverPortal$1 = {};

Object.defineProperty(PopoverPortal$1, "__esModule", { value: true });
PopoverPortal$1.PopoverPortal = void 0;
var react_1$5 = React__default;
var react_dom_1 = ReactDOM__default;
var PopoverPortal = function (_a) {
    var container = _a.container, element = _a.element, children = _a.children;
    react_1$5.useLayoutEffect(function () {
        container.appendChild(element);
        return function () {
            container.removeChild(element);
        };
    }, [container, element]);
    return react_dom_1.createPortal(children, element);
};
PopoverPortal$1.PopoverPortal = PopoverPortal;

var util = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getNudgedPopoverRect = exports.getNewPopoverRect = exports.popoverRectForPosition = exports.createContainer = exports.targetPositionHasChanged = exports.popoverStatesAreEqual = exports.rectsAreEqual = exports.arrayUnique = exports.Constants = void 0;
	exports.Constants = {
	    POPOVER_CONTAINER_CLASS_NAME: 'react-tiny-popover-container',
	    DEFAULT_ALIGN: 'center',
	    OBSERVER_THRESHOLDS: Array(1000)
	        .fill(null)
	        .map(function (_, i) { return i / 1000; })
	        .reverse(),
	    DEFAULT_POSITIONS: ['top', 'left', 'right', 'bottom'],
	    EMPTY_CLIENT_RECT: {
	        top: 0,
	        left: 0,
	        bottom: 0,
	        height: 0,
	        right: 0,
	        width: 0,
	    },
	};
	var arrayUnique = function (array) {
	    return array.filter(function (value, index, self) { return self.indexOf(value) === index; });
	};
	exports.arrayUnique = arrayUnique;
	var rectsAreEqual = function (rectA, rectB) {
	    return rectA === rectB ||
	        ((rectA === null || rectA === void 0 ? void 0 : rectA.bottom) === (rectB === null || rectB === void 0 ? void 0 : rectB.bottom) &&
	            (rectA === null || rectA === void 0 ? void 0 : rectA.height) === (rectB === null || rectB === void 0 ? void 0 : rectB.height) &&
	            (rectA === null || rectA === void 0 ? void 0 : rectA.left) === (rectB === null || rectB === void 0 ? void 0 : rectB.left) &&
	            (rectA === null || rectA === void 0 ? void 0 : rectA.right) === (rectB === null || rectB === void 0 ? void 0 : rectB.right) &&
	            (rectA === null || rectA === void 0 ? void 0 : rectA.top) === (rectB === null || rectB === void 0 ? void 0 : rectB.top) &&
	            (rectA === null || rectA === void 0 ? void 0 : rectA.width) === (rectB === null || rectB === void 0 ? void 0 : rectB.width));
	};
	exports.rectsAreEqual = rectsAreEqual;
	var popoverStatesAreEqual = function (stateA, stateB) {
	    return stateA === stateB ||
	        ((stateA === null || stateA === void 0 ? void 0 : stateA.align) === (stateB === null || stateB === void 0 ? void 0 : stateB.align) &&
	            (stateA === null || stateA === void 0 ? void 0 : stateA.nudgedLeft) === (stateB === null || stateB === void 0 ? void 0 : stateB.nudgedLeft) &&
	            (stateA === null || stateA === void 0 ? void 0 : stateA.nudgedTop) === (stateB === null || stateB === void 0 ? void 0 : stateB.nudgedTop) &&
	            stateA.padding === stateB.padding &&
	            exports.rectsAreEqual(stateA === null || stateA === void 0 ? void 0 : stateA.popoverRect, stateB === null || stateB === void 0 ? void 0 : stateB.popoverRect) &&
	            exports.rectsAreEqual(stateA === null || stateA === void 0 ? void 0 : stateA.childRect, stateB === null || stateB === void 0 ? void 0 : stateB.childRect) &&
	            (stateA === null || stateA === void 0 ? void 0 : stateA.position) === (stateB === null || stateB === void 0 ? void 0 : stateB.position));
	};
	exports.popoverStatesAreEqual = popoverStatesAreEqual;
	var targetPositionHasChanged = function (oldRect, newRect) {
	    return oldRect === undefined ||
	        oldRect.left !== newRect.left ||
	        oldRect.top !== newRect.top ||
	        oldRect.width !== newRect.width ||
	        oldRect.height !== newRect.height;
	};
	exports.targetPositionHasChanged = targetPositionHasChanged;
	var createContainer = function (containerStyle, containerClassName) {
	    var container = window.document.createElement('div');
	    if (containerClassName)
	        container.className = containerClassName;
	    Object.assign(container.style, containerStyle);
	    return container;
	};
	exports.createContainer = createContainer;
	var popoverRectForPosition = function (position, childRect, popoverRect, padding, align) {
	    var targetMidX = childRect.left + childRect.width / 2;
	    var targetMidY = childRect.top + childRect.height / 2;
	    var width = popoverRect.width, height = popoverRect.height;
	    var top;
	    var left;
	    switch (position) {
	        case 'left':
	            top = targetMidY - height / 2;
	            left = childRect.left - padding - width;
	            if (align === 'start') {
	                top = childRect.top;
	            }
	            if (align === 'end') {
	                top = childRect.bottom - height;
	            }
	            break;
	        case 'bottom':
	            top = childRect.bottom + padding;
	            left = targetMidX - width / 2;
	            if (align === 'start') {
	                left = childRect.left;
	            }
	            if (align === 'end') {
	                left = childRect.right - width;
	            }
	            break;
	        case 'right':
	            top = targetMidY - height / 2;
	            left = childRect.right + padding;
	            if (align === 'start') {
	                top = childRect.top;
	            }
	            if (align === 'end') {
	                top = childRect.bottom - height;
	            }
	            break;
	        default:
	            top = childRect.top - height - padding;
	            left = targetMidX - width / 2;
	            if (align === 'start') {
	                left = childRect.left;
	            }
	            if (align === 'end') {
	                left = childRect.right - width;
	            }
	            break;
	    }
	    return { top: top, left: left, width: width, height: height, right: left + width, bottom: top + height };
	};
	exports.popoverRectForPosition = popoverRectForPosition;
	var getNewPopoverRect = function (_a, boundaryInset) {
	    var position = _a.position, align = _a.align, childRect = _a.childRect, popoverRect = _a.popoverRect, parentRect = _a.parentRect, padding = _a.padding, reposition = _a.reposition;
	    var rect = exports.popoverRectForPosition(position, childRect, popoverRect, padding, align);
	    var boundaryViolation = reposition &&
	        ((position === 'top' && rect.top < parentRect.top + boundaryInset) ||
	            (position === 'left' && rect.left < parentRect.left + boundaryInset) ||
	            (position === 'right' && rect.right > parentRect.right - boundaryInset) ||
	            (position === 'bottom' && rect.bottom > parentRect.bottom - boundaryInset));
	    return {
	        rect: rect,
	        boundaryViolation: boundaryViolation,
	    };
	};
	exports.getNewPopoverRect = getNewPopoverRect;
	var getNudgedPopoverRect = function (popoverRect, parentRect, boundaryInset) {
	    var topBoundary = parentRect.top + boundaryInset;
	    var leftBoundary = parentRect.left + boundaryInset;
	    var rightBoundary = parentRect.right - boundaryInset;
	    var bottomBoundary = parentRect.bottom - boundaryInset;
	    var top = popoverRect.top < topBoundary ? topBoundary : popoverRect.top;
	    top = top + popoverRect.height > bottomBoundary ? bottomBoundary - popoverRect.height : top;
	    var left = popoverRect.left < leftBoundary ? leftBoundary : popoverRect.left;
	    left = left + popoverRect.width > rightBoundary ? rightBoundary - popoverRect.width : left;
	    return {
	        top: top,
	        left: left,
	        width: popoverRect.width,
	        height: popoverRect.height,
	        right: left + popoverRect.width,
	        bottom: top + popoverRect.height,
	    };
	};
	exports.getNudgedPopoverRect = getNudgedPopoverRect;
	
} (util));

var usePopover$1 = {};

var useElementRef$1 = {};

Object.defineProperty(useElementRef$1, "__esModule", { value: true });
useElementRef$1.useElementRef = void 0;
var react_1$4 = React__default;
var util_1$1 = util;
var useElementRef = function (containerClassName, containerStyle) {
    var element = react_1$4.useMemo(function () { return util_1$1.createContainer(containerStyle, containerClassName); }, [containerClassName, containerStyle]);
    return react_1$4.useRef(element);
};
useElementRef$1.useElementRef = useElementRef;

Object.defineProperty(usePopover$1, "__esModule", { value: true });
usePopover$1.usePopover = void 0;
var react_1$3 = React__default;
var util_1 = util;
var useElementRef_1 = useElementRef$1;
var usePopover = function (_a) {
    var childRef = _a.childRef, positions = _a.positions, containerClassName = _a.containerClassName, containerParent = _a.containerParent, contentLocation = _a.contentLocation, align = _a.align, padding = _a.padding, reposition = _a.reposition, boundaryInset = _a.boundaryInset, onPositionPopover = _a.onPositionPopover;
    var popoverRef = useElementRef_1.useElementRef(containerClassName, {
        position: 'fixed',
        overflow: 'visible',
        top: '0px',
        left: '0px',
    });
    var positionPopover = react_1$3.useCallback(function (positionIndex, childRect, popoverRect, parentRect) {
        var _a;
        if (positionIndex === void 0) { positionIndex = 0; }
        if (childRect === void 0) { childRect = (_a = childRef === null || childRef === void 0 ? void 0 : childRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(); }
        if (popoverRect === void 0) { popoverRect = popoverRef.current.getBoundingClientRect(); }
        if (parentRect === void 0) { parentRect = containerParent === null || containerParent === void 0 ? void 0 : containerParent.getBoundingClientRect(); }
        if (!childRect || !parentRect) {
            return;
        }
        if (contentLocation) {
            var _b = typeof contentLocation === 'function'
                ? contentLocation({
                    childRect: childRect,
                    popoverRect: popoverRect,
                    parentRect: parentRect,
                    padding: padding,
                    nudgedTop: 0,
                    nudgedLeft: 0,
                    boundaryInset: boundaryInset,
                })
                : contentLocation, inputTop = _b.top, inputLeft = _b.left;
            var left_1 = parentRect.left + inputLeft;
            var top_1 = parentRect.top + inputTop;
            popoverRef.current.style.transform = "translate(" + left_1 + "px, " + top_1 + "px)";
            onPositionPopover({
                childRect: childRect,
                popoverRect: popoverRect,
                parentRect: parentRect,
                padding: padding,
                nudgedTop: 0,
                nudgedLeft: 0,
                boundaryInset: boundaryInset,
            });
            return;
        }
        var isExhausted = positionIndex === positions.length;
        var position = isExhausted ? positions[0] : positions[positionIndex];
        var _c = util_1.getNewPopoverRect({
            childRect: childRect,
            popoverRect: popoverRect,
            parentRect: parentRect,
            position: position,
            align: align,
            padding: padding,
            reposition: reposition,
        }, boundaryInset), rect = _c.rect, boundaryViolation = _c.boundaryViolation;
        if (boundaryViolation && reposition && !isExhausted) {
            positionPopover(positionIndex + 1, childRect, popoverRect, parentRect);
            return;
        }
        var top = rect.top, left = rect.left, width = rect.width, height = rect.height;
        var shouldNudge = reposition && !isExhausted;
        var _d = util_1.getNudgedPopoverRect(rect, parentRect, boundaryInset), nudgedLeft = _d.left, nudgedTop = _d.top;
        var finalTop = top;
        var finalLeft = left;
        if (shouldNudge) {
            finalTop = nudgedTop;
            finalLeft = nudgedLeft;
        }
        popoverRef.current.style.transform = "translate(" + finalLeft + "px, " + finalTop + "px)";
        onPositionPopover({
            childRect: childRect,
            popoverRect: {
                top: finalTop,
                left: finalLeft,
                width: width,
                height: height,
                right: finalLeft + width,
                bottom: finalTop + height,
            },
            parentRect: parentRect,
            position: position,
            align: align,
            padding: padding,
            nudgedTop: nudgedTop - top,
            nudgedLeft: nudgedLeft - left,
            boundaryInset: boundaryInset,
        });
    }, [
        childRef,
        popoverRef,
        positions,
        align,
        padding,
        reposition,
        boundaryInset,
        containerParent,
        contentLocation,
        onPositionPopover,
    ]);
    return [positionPopover, popoverRef];
};
usePopover$1.usePopover = usePopover;

var useMemoizedArray$1 = {};

Object.defineProperty(useMemoizedArray$1, "__esModule", { value: true });
useMemoizedArray$1.useMemoizedArray = void 0;
var react_1$2 = React__default;
var useMemoizedArray = function (externalArray) {
    var prevArrayRef = react_1$2.useRef(externalArray);
    var array = react_1$2.useMemo(function () {
        if (prevArrayRef.current === externalArray)
            return prevArrayRef.current;
        if (prevArrayRef.current.length !== externalArray.length) {
            prevArrayRef.current = externalArray;
            return externalArray;
        }
        for (var i = 0; i < externalArray.length; i += 1) {
            if (externalArray[i] !== prevArrayRef.current[i]) {
                prevArrayRef.current = externalArray;
                return externalArray;
            }
        }
        return prevArrayRef.current;
    }, [externalArray]);
    return array;
};
useMemoizedArray$1.useMemoizedArray = useMemoizedArray;

var useArrowContainer$1 = {};

var __assign$1 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
Object.defineProperty(useArrowContainer$1, "__esModule", { value: true });
useArrowContainer$1.useArrowContainer = void 0;
var react_1$1 = React__default;
var useArrowContainer = function (_a) {
    var childRect = _a.childRect, popoverRect = _a.popoverRect, position = _a.position, arrowSize = _a.arrowSize, arrowColor = _a.arrowColor;
    var arrowContainerStyle = react_1$1.useMemo(function () {
        return ({
            padding: arrowSize,
        });
    }, [arrowSize]);
    var arrowStyle = react_1$1.useMemo(function () {
        return (__assign$1({ position: 'absolute' }, (function () {
            var arrowWidth = arrowSize * 2;
            var top = childRect.top - popoverRect.top + childRect.height / 2 - arrowWidth / 2;
            var left = childRect.left - popoverRect.left + childRect.width / 2 - arrowWidth / 2;
            var lowerBound = arrowSize;
            var leftUpperBound = popoverRect.width - arrowSize;
            var topUpperBound = popoverRect.height - arrowSize;
            left = left < lowerBound ? lowerBound : left;
            left = left + arrowWidth > leftUpperBound ? leftUpperBound - arrowWidth : left;
            top = top < lowerBound ? lowerBound : top;
            top = top + arrowWidth > topUpperBound ? topUpperBound - arrowWidth : top;
            top = Number.isNaN(top) ? 0 : top;
            left = Number.isNaN(left) ? 0 : left;
            switch (position) {
                case 'right':
                    return {
                        borderTop: arrowSize + "px solid transparent",
                        borderBottom: arrowSize + "px solid transparent",
                        borderRight: arrowSize + "px solid " + arrowColor,
                        left: 0,
                        top: top,
                    };
                case 'left':
                    return {
                        borderTop: arrowSize + "px solid transparent",
                        borderBottom: arrowSize + "px solid transparent",
                        borderLeft: arrowSize + "px solid " + arrowColor,
                        right: 0,
                        top: top,
                    };
                case 'bottom':
                    return {
                        borderLeft: arrowSize + "px solid transparent",
                        borderRight: arrowSize + "px solid transparent",
                        borderBottom: arrowSize + "px solid " + arrowColor,
                        top: 0,
                        left: left,
                    };
                case 'top':
                    return {
                        borderLeft: arrowSize + "px solid transparent",
                        borderRight: arrowSize + "px solid transparent",
                        borderTop: arrowSize + "px solid " + arrowColor,
                        bottom: 0,
                        left: left,
                    };
                default:
                    return {
                        display: 'hidden',
                    };
            }
        })()));
    }, [
        arrowColor,
        arrowSize,
        childRect.height,
        childRect.left,
        childRect.top,
        childRect.width,
        popoverRect.height,
        popoverRect.left,
        popoverRect.top,
        popoverRect.width,
        position,
    ]);
    return {
        arrowContainerStyle: arrowContainerStyle,
        arrowStyle: arrowStyle,
    };
};
useArrowContainer$1.useArrowContainer = useArrowContainer;

var ArrowContainer$1 = {};

var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(ArrowContainer$1, "__esModule", { value: true });
ArrowContainer$1.ArrowContainer = void 0;
var jsx_runtime_1 = jsxRuntimeExports;
var react_1 = React__default;
var useArrowContainer_1 = useArrowContainer$1;
var ArrowContainer = function (_a) {
    var childRect = _a.childRect, popoverRect = _a.popoverRect, position = _a.position, arrowColor = _a.arrowColor, arrowSize = _a.arrowSize, arrowClassName = _a.arrowClassName, externalArrowStyle = _a.arrowStyle, className = _a.className, children = _a.children, externalArrowContainerStyle = _a.style;
    var _b = useArrowContainer_1.useArrowContainer({
        childRect: childRect,
        popoverRect: popoverRect,
        position: position,
        arrowColor: arrowColor,
        arrowSize: arrowSize,
    }), arrowContainerStyle = _b.arrowContainerStyle, arrowStyle = _b.arrowStyle;
    var mergedContainerStyle = react_1.useMemo(function () { return (__assign(__assign({}, arrowContainerStyle), externalArrowContainerStyle)); }, [arrowContainerStyle, externalArrowContainerStyle]);
    var mergedArrowStyle = react_1.useMemo(function () { return (__assign(__assign({}, arrowStyle), externalArrowStyle)); }, [arrowStyle, externalArrowStyle]);
    return (jsx_runtime_1.jsxs("div", __assign({ className: className, style: mergedContainerStyle }, { children: [jsx_runtime_1.jsx("div", { style: mergedArrowStyle, className: arrowClassName }, void 0), children] }), void 0));
};
ArrowContainer$1.ArrowContainer = ArrowContainer;

(function (exports) {
	var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Popover = exports.usePopover = exports.ArrowContainer = exports.useArrowContainer = void 0;
	var jsx_runtime_1 = jsxRuntimeExports;
	var react_1 = React__default;
	var PopoverPortal_1 = PopoverPortal$1;
	var util_1 = util;
	var usePopover_1 = usePopover$1;
	Object.defineProperty(exports, "usePopover", { enumerable: true, get: function () { return usePopover_1.usePopover; } });
	var useMemoizedArray_1 = useMemoizedArray$1;
	var useArrowContainer_1 = useArrowContainer$1;
	Object.defineProperty(exports, "useArrowContainer", { enumerable: true, get: function () { return useArrowContainer_1.useArrowContainer; } });
	var ArrowContainer_1 = ArrowContainer$1;
	Object.defineProperty(exports, "ArrowContainer", { enumerable: true, get: function () { return ArrowContainer_1.ArrowContainer; } });
	exports.Popover = react_1.forwardRef(function (_a, externalRef) {
	    var isOpen = _a.isOpen, children = _a.children, content = _a.content, _b = _a.positions, externalPositions = _b === void 0 ? util_1.Constants.DEFAULT_POSITIONS : _b, _c = _a.align, align = _c === void 0 ? util_1.Constants.DEFAULT_ALIGN : _c, _d = _a.padding, padding = _d === void 0 ? 0 : _d, _e = _a.reposition, reposition = _e === void 0 ? true : _e, _f = _a.containerParent, containerParent = _f === void 0 ? window.document.body : _f, _g = _a.containerClassName, containerClassName = _g === void 0 ? 'react-tiny-popover-container' : _g, containerStyle = _a.containerStyle, contentLocation = _a.contentLocation, _h = _a.boundaryInset, boundaryInset = _h === void 0 ? 0 : _h, onClickOutside = _a.onClickOutside;
	    var positions = useMemoizedArray_1.useMemoizedArray(externalPositions);
	    // TODO: factor prevs out into a custom prevs hook
	    var prevIsOpen = react_1.useRef(false);
	    var prevPositions = react_1.useRef();
	    var prevContentLocation = react_1.useRef();
	    var prevReposition = react_1.useRef(reposition);
	    var childRef = react_1.useRef();
	    var _j = react_1.useState({
	        align: align,
	        nudgedLeft: 0,
	        nudgedTop: 0,
	        position: positions[0],
	        padding: padding,
	        childRect: util_1.Constants.EMPTY_CLIENT_RECT,
	        popoverRect: util_1.Constants.EMPTY_CLIENT_RECT,
	        parentRect: util_1.Constants.EMPTY_CLIENT_RECT,
	        boundaryInset: boundaryInset,
	    }), popoverState = _j[0], setPopoverState = _j[1];
	    var onPositionPopover = react_1.useCallback(function (popoverState) { return setPopoverState(popoverState); }, []);
	    var _k = usePopover_1.usePopover({
	        childRef: childRef,
	        containerClassName: containerClassName,
	        containerParent: containerParent,
	        contentLocation: contentLocation,
	        positions: positions,
	        align: align,
	        padding: padding,
	        boundaryInset: boundaryInset,
	        reposition: reposition,
	        onPositionPopover: onPositionPopover,
	    }), positionPopover = _k[0], popoverRef = _k[1];
	    react_1.useLayoutEffect(function () {
	        var shouldUpdate = true;
	        var updatePopover = function () {
	            var _a, _b;
	            if (isOpen && shouldUpdate) {
	                var childRect = (_a = childRef === null || childRef === void 0 ? void 0 : childRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
	                var popoverRect = (_b = popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
	                if (childRect != null &&
	                    popoverRect != null &&
	                    (!util_1.rectsAreEqual(childRect, {
	                        top: popoverState.childRect.top,
	                        left: popoverState.childRect.left,
	                        width: popoverState.childRect.width,
	                        height: popoverState.childRect.height,
	                        bottom: popoverState.childRect.top + popoverState.childRect.height,
	                        right: popoverState.childRect.left + popoverState.childRect.width,
	                    }) ||
	                        popoverRect.width !== popoverState.popoverRect.width ||
	                        popoverRect.height !== popoverState.popoverRect.height ||
	                        popoverState.padding !== padding ||
	                        popoverState.align !== align ||
	                        positions !== prevPositions.current ||
	                        contentLocation !== prevContentLocation.current ||
	                        reposition !== prevReposition.current)) {
	                    positionPopover();
	                }
	                // TODO: factor prev checks out into the custom prevs hook
	                if (positions !== prevPositions.current) {
	                    prevPositions.current = positions;
	                }
	                if (contentLocation !== prevContentLocation.current) {
	                    prevContentLocation.current = contentLocation;
	                }
	                if (reposition !== prevReposition.current) {
	                    prevReposition.current = reposition;
	                }
	                if (shouldUpdate) {
	                    window.requestAnimationFrame(updatePopover);
	                }
	            }
	            prevIsOpen.current = isOpen;
	        };
	        window.requestAnimationFrame(updatePopover);
	        return function () {
	            shouldUpdate = false;
	        };
	    }, [
	        align,
	        contentLocation,
	        isOpen,
	        padding,
	        popoverRef,
	        popoverState.align,
	        popoverState.childRect.height,
	        popoverState.childRect.left,
	        popoverState.childRect.top,
	        popoverState.childRect.width,
	        popoverState.padding,
	        popoverState.popoverRect.height,
	        popoverState.popoverRect.width,
	        positionPopover,
	        positions,
	        reposition,
	    ]);
	    react_1.useEffect(function () {
	        var popoverElement = popoverRef.current;
	        Object.assign(popoverElement.style, containerStyle);
	        return function () {
	            Object.keys(containerStyle !== null && containerStyle !== void 0 ? containerStyle : {}).forEach(function (key) {
	                return delete popoverElement.style[key];
	            });
	        };
	    }, [containerStyle, isOpen, popoverRef]);
	    var handleOnClickOutside = react_1.useCallback(function (e) {
	        var _a, _b;
	        if (isOpen &&
	            !((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) &&
	            !((_b = childRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target))) {
	            onClickOutside === null || onClickOutside === void 0 ? void 0 : onClickOutside(e);
	        }
	    }, [isOpen, onClickOutside, popoverRef]);
	    var handleWindowResize = react_1.useCallback(function () {
	        if (childRef.current) {
	            window.requestAnimationFrame(function () { return positionPopover(); });
	        }
	    }, [positionPopover]);
	    react_1.useEffect(function () {
	        window.addEventListener('click', handleOnClickOutside);
	        window.addEventListener('resize', handleWindowResize);
	        return function () {
	            window.removeEventListener('click', handleOnClickOutside);
	            window.removeEventListener('resize', handleWindowResize);
	        };
	    }, [handleOnClickOutside, handleWindowResize]);
	    var handleRef = react_1.useCallback(function (node) {
	        childRef.current = node;
	        if (externalRef != null) {
	            if (typeof externalRef === 'object') {
	                externalRef.current = node;
	            }
	            else if (typeof externalRef === 'function') {
	                externalRef(node);
	            }
	        }
	    }, [externalRef]);
	    var renderChild = function () {
	        return react_1.cloneElement(children, {
	            ref: handleRef,
	        });
	    };
	    var renderPopover = function () {
	        if (!isOpen)
	            return null;
	        return (jsx_runtime_1.jsx(PopoverPortal_1.PopoverPortal, __assign({ element: popoverRef.current, container: containerParent }, { children: typeof content === 'function' ? content(popoverState) : content }), void 0));
	    };
	    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [renderChild(), renderPopover()] }, void 0));
	});
	
} (Popover));

var css_248z = "[data-gene-ui-version=\"2.15.1\"] .popover-positioner{--popover-border-radius:1rem;--popover-shadow:0 0.2rem 0.4rem 0 #0000000d,0 0 0 1px rgba(var(--background-sc-rgb),0.08);z-index:400}[data-gene-ui-version=\"2.15.1\"] .popover-positioner.cr-smooth-radius{--popover-border-radius:0.4rem}[data-gene-ui-version=\"2.15.1\"] .popover-positioner.mobile-view{--popover-border-radius:0.8rem 0.8rem 0 0;--popover-shadow:0 -1px 0.2rem 0 #0000000d;bottom:0;left:0!important;overflow:hidden;position:fixed!important;top:0!important;transform:translate(0)!important;width:100%}[data-gene-ui-version=\"2.15.1\"] .popover-positioner .popover-top-bottom-padding{padding:1rem 0;width:100%}[data-gene-ui-version=\"2.15.1\"] .popover-positioner .popover-top-bottom-padding>div[style*=width]{width:100%!important}[data-gene-ui-version=\"2.15.1\"] .popover{width:100%}[data-gene-ui-version=\"2.15.1\"] .popover-positioner.mobile-view .popover{height:100%;position:relative}[data-gene-ui-version=\"2.15.1\"] .popover-positioner-disable{margin-top:5px;position:inherit!important;transform:none!important}[data-gene-ui-version=\"2.15.1\"] .popover-track{width:100%}[data-gene-ui-version=\"2.15.1\"] .popover-content{background:var(--background);border-radius:var(--popover-border-radius);box-shadow:var(--popover-shadow);overflow:hidden;padding:0 0 env(safe-area-inset-bottom);transition:padding .4s;width:100%}[data-gene-ui-version=\"2.15.1\"] .popover-positioner.mobile-view .popover-content{-webkit-overflow-scrolling:auto;bottom:0;left:0;max-height:calc(100% - 10rem);overflow-x:hidden;overflow-y:auto;position:absolute;z-index:1}[data-gene-ui-version=\"2.15.1\"] .popover-positioner.mobile-view[style*=\"opacity: 0\"] .popover-content{transform:translateY(100%)}[data-gene-ui-version=\"2.15.1\"] .popover-positioner.mobile-view .popover-content{transform:translateY(0)}[data-gene-ui-version=\"2.15.1\"] .popover-mobile-backdrop{background:#0003;height:100%;left:0;opacity:1;position:absolute;top:0;width:100%;z-index:0}[data-gene-ui-version=\"2.15.1\"] .popover-footer,[data-gene-ui-version=\"2.15.1\"] .popover-header{background:var(--background);position:-webkit-sticky;position:sticky;z-index:1}[data-gene-ui-version=\"2.15.1\"] .popover-header{border-bottom:1px solid rgba(var(--background-sc-rgb),.1);top:0}[data-gene-ui-version=\"2.15.1\"] .popover-footer{align-items:stretch;border-top:1px solid rgba(var(--background-sc-rgb),.1);bottom:calc(env(safe-area-inset-bottom)*-1);display:flex;padding:0 0 env(safe-area-inset-bottom);transition:padding .4s}[data-gene-ui-version=\"2.15.1\"] .popover-body{position:relative;z-index:0}[data-gene-ui-version=\"2.15.1\"] .popover-search{padding:1.4rem 1.5rem}[data-gene-ui-version=\"2.15.1\"] .empty-data-holder{align-items:center;display:flex;height:19rem;justify-content:center;width:100%}[data-gene-ui-version=\"2.15.1\"] .popover-disabled{opacity:.5;pointer-events:none;transition:opacity .5s}";
styleInject(css_248z);

const PopoverV2 = /*#__PURE__*/forwardRef((props, ref) => {
  var _popoverRef$current4;
  const {
    nativeOutsideClick,
    extendTargetWidth,
    disableReposition,
    disableTransform,
    containerParent,
    scrollbarNeeded,
    onClickOutside,
    trackClassName,
    toggleHandler,
    cornerRadius,
    getScrollRef,
    onSwipedDown,
    contentRef,
    screenType,
    minHeight,
    maxHeight,
    className,
    swipeable,
    children,
    position,
    disabled,
    Content,
    padding,
    behave,
    Header,
    Footer,
    isOpen,
    align,
    scrollbarProps,
    ...restProps
  } = props;
  const {
    geneUIProviderRef
  } = useContext(GeneUIDesignSystemContext);
  const popoverRef = useRef(null);
  const popoverBodyRef = useRef(null);
  const popoverTrackRef = useRef(null);
  const [updateKey, setUpdateKey] = useState(0);
  const [targetWidth, setTargetWidth] = useState(null);
  const [popoverOpened, setPopoverOpened] = useState(false);
  const [swipingPosition, setSwipingPosition] = useState(0);
  const {
    isMobile
  } = useDeviceType(screenType);
  const isControlled = ('isOpen' in props);
  const popoverState = isControlled ? isOpen : popoverOpened;
  const positions = useMemo(() => Array.isArray(position) ? position : [position], [position]);
  useEffect(() => {
    document.documentElement.classList[popoverState ? 'add' : 'remove'](popoverV2Config.onOpenClassName);
  }, [popoverState]);
  useEffect(() => {
    setUpdateKey(Date.now());
  }, [isMobile, cornerRadius]);
  useEffect(() => {
    var _popoverRef$current;
    if (popoverRef.current && (_popoverRef$current = popoverRef.current) !== null && _popoverRef$current !== void 0 && _popoverRef$current.offsetWidth) {
      var _popoverRef$current2;
      setTargetWidth((_popoverRef$current2 = popoverRef.current) === null || _popoverRef$current2 === void 0 ? void 0 : _popoverRef$current2.offsetWidth);
      const debouncedHandleResize = debounce(() => {
        var _popoverRef$current3;
        setTargetWidth((_popoverRef$current3 = popoverRef.current) === null || _popoverRef$current3 === void 0 ? void 0 : _popoverRef$current3.offsetWidth);
      }, 20);
      window.addEventListener('resize', debouncedHandleResize);
      return () => window.removeEventListener('resize', debouncedHandleResize);
    }
  }, [(_popoverRef$current4 = popoverRef.current) === null || _popoverRef$current4 === void 0 ? void 0 : _popoverRef$current4.offsetWidth]);

  /* *** START SWIPE FUNCTIONALITY *** */
  const checkBodyContains = event => popoverBodyRef.current.contains(event.target);
  const handleSwiped = event => setSwipingPosition(0);
  const handleSwipedDown = touchEvent => {
    !checkBodyContains(touchEvent.event) && onSwipedDown(touchEvent);
  };
  const handleSwiping = useCallback(_ref => {
    let {
      deltaY,
      event
    } = _ref;
    if (checkBodyContains(event)) {
      stopEvent(event);
    } else if (deltaY >= 0) {
      setSwipingPosition(deltaY * -1);
    }
  }, [popoverBodyRef, setSwipingPosition]);
  const swipeHandlers = useSwipeable(useMemo(() => swipeable ? {
    onSwipedDown: handleSwipedDown,
    onSwiping: handleSwiping,
    onSwiped: handleSwiped
  } : {}, [swipeable, handleSwipedDown, handleSwiping, handleSwiped]));
  /* *** END SWIPE FUNCTIONALITY *** */

  /* *** START OPEN/CLOSE FUNCTIONALITY *** */
  const togglePopupOpened = useCallback(event => {
    stopEvent(event);
    if (isControlled) {
      toggleHandler(event, isOpen);
    } else {
      setPopoverOpened(status => {
        toggleHandler(event, !status);
        return !status;
      });
    }
  }, [isControlled, toggleHandler, isOpen]);
  const handleTrackClick = useCallback(event => {
    if (!disabled) {
      if (behave === 'toggle') {
        togglePopupOpened(event);
      } else if (!isControlled && behave === 'open') {
        setPopoverOpened(true);
      }
    }
  }, [disabled, isControlled, behave, togglePopupOpened]);
  const handleOutsideClick = useClickOutside(event => {
    if (popoverRef && !popoverRef.current.contains(event.target)) {
      onClickOutside(event);
      if (!isControlled) {
        setPopoverOpened(false);
      }
    }
  });
  /* *** END OPEN/CLOSE FUNCTIONALITY *** */

  /* *** START GENERATE REFS *** */
  const generatePopoverRef = useCallback(element => {
    popoverRef && (popoverRef.current = element);
    ref && (ref.current = element);
  }, [ref]);
  const generateContentRef = useCallback(element => {
    isMobile && getScrollRef(element);
    handleOutsideClick(element);
    if (contentRef) {
      typeof contentRef === 'function' ? contentRef(element) : contentRef.current = element;
    }
  }, [isMobile, contentRef, getScrollRef]);
  /* *** END GENERATE REFS *** */
  const portalContent = /*#__PURE__*/React__default.createElement("div", swipeHandlers, /*#__PURE__*/React__default.createElement("ul", {
    onClick: stopEvent,
    ref: generateContentRef,
    className: "popover-content",
    style: {
      bottom: swipingPosition,
      width: extendTargetWidth && !isMobile && targetWidth || null
    }
  }, Header && /*#__PURE__*/React__default.createElement("li", {
    className: "popover-header"
  }, Header), /*#__PURE__*/React__default.createElement("li", {
    ref: popoverBodyRef,
    className: "popover-body"
  }, scrollbarNeeded && !isMobile ? /*#__PURE__*/React__default.createElement(CustomScrollbar, _extends({
    ref: scrollbar => {
      scrollbar && getScrollRef(scrollbar.view);
    },
    autoHeight: true,
    autoHeightMax: maxHeight,
    autoHeightMin: minHeight
  }, scrollbarProps), Content) : Content), Footer && /*#__PURE__*/React__default.createElement("li", {
    className: "popover-footer"
  }, Footer)), isMobile && /*#__PURE__*/React__default.createElement("div", {
    className: "popover-mobile-backdrop",
    onClick: togglePopupOpened
  }));
  const childElement = useMemo(() => /*#__PURE__*/React__default.createElement("div", {
    onClick: handleTrackClick,
    className: classnames('popover-track cursor-pointer', trackClassName, {
      'popover-opened': popoverState,
      'popover-disabled': disabled
    })
  }, children), [popoverTrackRef, children, trackClassName, popoverState, disabled, handleTrackClick]);
  const containerParentMemo = useMemo(() => containerParent || geneUIProviderRef.current ? {
    containerParent: containerParent || geneUIProviderRef.current
  } : {}, [containerParent, geneUIProviderRef.current]);
  if (!Content) {
    return childElement;
  }
  return /*#__PURE__*/React__default.createElement(Popover.Popover, _extends({
    key: updateKey,
    ref: generatePopoverRef,
    align: align,
    positions: positions,
    padding: padding,
    onClickOutside: nativeOutsideClick,
    isOpen: popoverState,
    content: portalContent,
    reposition: !isMobile && disableReposition,
    containerStyle: {
      overflow: null
    },
    containerClassName: classnames('popover-positioner', "cr-".concat(cornerRadius), className, {
      'mobile-view': isMobile,
      'popover-positioner-disable': disableTransform && containerParent && !isMobile
    }),
    children: childElement
  }, containerParentMemo, restProps));
});
PopoverV2.propTypes = {
  /**
   * The component that need to be displayed in the Popover. Any valid React node
   */
  Content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * The component that need to be displayed as Popover header. Any valid React node
   */
  Header: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * The component that need to be displayed as Popover footer. Any valid React node
   */
  Footer: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * The component which click needs to trigger the Popover to open. Need to passed as child to Popover. Any valid React node
   */
  children: PropTypes.node,
  /**
   * The Popover will get the width of its child. The property will not work when "width" prop is specified
   */
  extendTargetWidth: PropTypes.bool,
  /**
   * The Popover "Content" minimum scroll height
   */
  minHeight: PropTypes.number,
  /**
   * The Popover "Content" maximum scroll height. Will not work when the "screenType" is "mobile"
   */
  maxHeight: PropTypes.number,
  /**
   * Use this prop to control the Popover. Note the component will start not to open and close automatically
   */
  isOpen: PropTypes.bool,
  /**
   * Popover position to be displayed
   */
  position: PropTypes.oneOfType([PropTypes.oneOf(popoverV2Config.position), PropTypes.arrayOf(PropTypes.oneOf(popoverV2Config.position))]),
  /**
   * Will called each time the popover need to be toggled(child click, close button click, backdrop click).
   * (event: Event, isOpen: bool) => void
   */
  toggleHandler: PropTypes.func,
  /**
   * Possible values are start, center, and end.
   * If start is specified, the popover content's top or left location is aligned with its target's.
   * With end specified, the content's bottom or right location is aligned with its target's.
   * If center is specified, the popover content and target's centers are aligned.
   */
  align: PropTypes.oneOf(popoverV2Config.align),
  /**
   * If you'd like to apply styles to the single container div that your popover content is rendered within via stylesheets,
   * you can specify a custom className for the container here.
   */
  className: PropTypes.string,
  /**
   * This number determines the gap, in pixels, between your target content and your popover content
   */
  padding: PropTypes.number,
  /**
   * If this property is enabled, rather than the popover content repositioning on a boundary collision,
   * the popover content container will move beyond the window's bounds.
   * You are, however, supplied with nudgedLeft and nudgedTop values, so you may choose to handle content overflow as you wish.
   */
  disableReposition: PropTypes.bool,
  /**
   * Popover corner radius
   */
  cornerRadius: PropTypes.oneOf(popoverV2Config.cornerRadius),
  /**
   * The switch between mobile and desktop version of Popover will be applied automatically, when the prop is not specified.
   * When the prop is present it must be changed from outside.
   */
  screenType: PropTypes.oneOf(screenTypes),
  /**
   * Specify does Popover needs to be toggled on child click
   */
  behave: PropTypes.oneOf(popoverV2Config.behave),
  /**
   * Given content prop can have its own scroll, and with this props we can use/not use default scroll that has popover
   */
  scrollbarNeeded: PropTypes.bool,
  /**
   * Popover content ref
   */
  contentRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  disabled: PropTypes.bool,
  getScrollRef: PropTypes.func,
  /**
   * This number specifies the inset around your containerParent's border
   * that boundary violations are determined at. Defaults to 0. Can be negative.
   */
  boundaryInset: PropTypes.number,
  /**
   * If you want to apply styles to the popup tracker div where your children are using
   * stylesheets, you can provide a custom class name for the container here.
   */
  trackClassName: PropTypes.string,
  /*
   * After DOWN swipe  (SwipeEventData) => void
   */
  onSwipedDown: PropTypes.func,
  swipeable: PropTypes.bool,
  /*
   * If react-tiny-popover detects a click event outside of the target and outside
   * of the popover, you may handle this event here, in the form of (e: MouseEvent) => void.
   */
  onClickOutside: PropTypes.func,
  nativeOutsideClick: PropTypes.func,
  /*
   * props for scrollbar
   */
  scrollbarProps: PropTypes.shape({
    ...CustomScrollbar.propTypes
  }),
  /*
   * When disableTransform is true and containerParent has ref.current, the popover generates in a dropdown wrapper instead of closing the body tag, and the position will not calculate.
   */
  disableTransform: PropTypes.bool,
  /*
   * Provide an HTML element ref here to have your popover content appended to that element rather than document.body. This is useful if you'd like your popover to sit at a particular place within the DOM.
   */
  containerParent: PropTypes.object
};
PopoverV2.defaultProps = {
  cornerRadius: popoverV2Config.cornerRadius[0],
  position: popoverV2Config.position,
  align: popoverV2Config.align[0],
  toggleHandler: noop,
  behave: popoverV2Config.behave[0],
  extendTargetWidth: true,
  disableReposition: true,
  disableTransform: false,
  minHeight: 0,
  maxHeight: 510,
  padding: 10,
  getScrollRef: noop,
  scrollbarNeeded: true,
  swipeable: false,
  onSwipedDown: noop,
  onClickOutside: noop,
  nativeOutsideClick: noop
};

export { PopoverV2 as P, jsxRuntimeExports as j };
